import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static values = {
    url: String,
    copiedText: { type: String, default: "Kopiert!" }
  };

  async copyLink(event) {
    const button = event.currentTarget;
    const originalTitle = button.getAttribute("title");

    try {
      await navigator.clipboard.writeText(this.urlValue);

      // Visual feedback
      button.setAttribute("title", this.copiedTextValue);
      button.classList.add("copied");

      setTimeout(() => {
        button.setAttribute("title", originalTitle);
        button.classList.remove("copied");
      }, 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  }
}
